export const currentMonth = () => new Date().toLocaleDateString("sv-SE").slice(0, 7);

export const shiftMonth = (ym, n) => {
  const [y, m] = ym.split("-").map(Number);
  const d = new Date(y, m - 1 + n, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const monthLabel = (ym, short = false) => {
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString("fr-FR", short ? { month: "short" } : { month: "long", year: "numeric" });
};

export const fmtL100 = (v) => (v === null || v === undefined ? "—" : `${v.toFixed(2)} L/100`);
